<template>
  <div
    class="product-usp product-usp__hide"
  >
    <div
      v-for="(usp, index) of sortedUspMetaobject"
      :key="`${index}-${usp.title}`"
      class="product-usp__card"
    >
      <responsive-image
        :image="usp.image"
        :ratio="255/320"
      />

      <div
        class="text-heading-m"
        v-text="usp.title"
      />

      <div
        class="text-body-s-regular"
        v-html="usp.description"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Product usp (product-usp)
 * -----------------------------------------------------------------------------
 * Product USP metaobject.
 *
 */
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'ProductUsp',

  components: {
    ResponsiveImage,
  },

  props: {
    uspMetaobject: {
      type: [Boolean, Array],
      default: false,
    },
  },

  data() {
    return {
      sortedUspMetaobject: [],
    }
  },

  mounted() {
    this.sortMetaobjectEntries()
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment","1004113370"]);
  },

  methods: {

    /**
     * Update order of metaobject entry based on property.
     * Entries with no order is pushed to the end of the list.
     */
    sortMetaobjectEntries () {
      if (Array.isArray(this.uspMetaobject)) {

      this.sortedUspMetaobject = [...this.uspMetaobject].sort((a, b) => {
        if (a.order === undefined) return 1;
        if (b.order === undefined) return -1;
        return a.order - b.order;
      });
    }
    },
  },
}
</script>

<style lang="scss">
@import './product-usp';
</style>
